import { Notice, Stack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

export const HasSomeImpersonateWarning: React.FC = () => {
  return (
    <Stack>
      <Notice
        testID="all-advisors-warning-notice"
        backgroundColor={Utils.ColorToken.WithOpacity(
          'feedback.attention.lightest',
          'opacity.medium'
        )}
        textObjects={[
          { text: 'Atenção: ', variant: 'bold' },
          {
            text: 'Esta tela ',
            variant: 'regular',
          },
          {
            text: 'não está disponível ',
            variant: 'bold',
          },
          {
            text: 'para a visualização de outro assessor. Selecione sua filial inicial e seu próprio acesso.',
            variant: 'regular',
          },
        ]}
      />
    </Stack>
  );
};
